import { useQuery } from '@tanstack/react-query';

import { getContinuousFeedback, getFilters } from 'services/analytics/continuousFeedback';

const getData = async ({
  isExpandedViewRequired,
  cohort,
  groupByKeys,
  orderBy,
  parentUuid,
  splitByKeys,
  dateRange,
  isNewCompetencyEnabled,
}) => {
  try {
    const res = await getContinuousFeedback({
      isExpandedViewRequired,
      cohort,
      groupByKeys,
      orderBy,
      parentUuid,
      splitByKeys,
      dateRange,
    });
    const sanProgressColumns = res?.columns?.filter((column) => column.id !== '5');
    const { columns = [], values = [] } = res ?? {};
    return { columns: isNewCompetencyEnabled ? sanProgressColumns : columns, values };
  } catch (err) {
    console.error('Error fetching analytics data for levelup : ', err);
  }
};

export const useFetchLevelUpAnalyticsData = ({
  isExpandedViewRequired,
  cohort,
  groupByKeys,
  orderBy,
  parentUuid,
  splitByKeys,
  dateRange,
  isNewCompetencyEnabled,
}) =>
  useQuery(
    ['CFAnalytics', cohort?.id, groupByKeys?.keyName, splitByKeys, dateRange, parentUuid, isNewCompetencyEnabled],
    () =>
      getData({
        isExpandedViewRequired,
        cohort,
        groupByKeys,
        orderBy,
        parentUuid,
        splitByKeys,
        dateRange,
        isNewCompetencyEnabled,
      }),
    { enabled: !!cohort && Boolean(dateRange.endTS && dateRange.startTS), refetchOnWindowFocus: false }
  );

const fetchFilters = async () => {
  try {
    const res = await getFilters();
    return res;
  } catch (err) {
    console.error('Error in fetching analytics filters for CF : ', err);
  }
};

export const useFetchCFAnalyticsFilters = () =>
  useQuery(['CFAnalyticsFilters'], () => fetchFilters(), {
    refetchOnWindowFocus: false,
  });

// export const useFetchLevelUpAnalyticsData = ({
//   isExpandedViewRequired,
//   cohort,
//   groupByKeys,
//   orderBy,
//   parentUuid,
//   splitByKeys,
//   dateRange
// }) => {
//   const { isLoading, run, isIdle, isError, setError, error } = useAsync();
//   const [data, setData] = useState({ values: [], columns: [] });

//   useEffect(() => {
//     if (cohort) {
//       run(
//         getData({
//           isExpandedViewRequired,
//           cohort,
//           groupByKeys,
//           orderBy,
//           parentUuid,
//           splitByKeys,
//           dateRange,
//           setData,
//           setError
//         })
//       );
//     }
//   }, [cohort, groupByKeys, dateRange]);

//   return { data, isLoading, isIdle, isError, error };
// };
